import React from "react";
import { Link } from "react-router-dom";
import { useCart } from "../context/CartContext";
import { toast } from "sonner";

const ProductCard = ({ product }) => {
    const { add } = useCart();

    const onAdd = (e) => {
        e.preventDefault();
        e.stopPropagation();
        add(product, 1);
        toast.success(`${product.name} added to cart.`);
    };

    return (
        <Link
            to={`/product/${product.slug}`}
            data-testid={`product-card-${product.slug}`}
            className="group block"
        >
            <div className="product-image-wrap aspect-[4/5]">
                <img
                    src={product.images?.[0]}
                    alt={product.name}
                    loading="lazy"
                    className="product-image w-full h-full object-cover"
                />
            </div>
            <div className="mt-5 flex justify-between items-start gap-4">
                <div className="flex-1">
                    <h3 className="font-serif text-xl text-[#1C1C1A] leading-tight">
                        {product.name}
                    </h3>
                    <p className="mt-2 text-sm text-[#737562] leading-relaxed">
                        {product.short_description}
                    </p>
                </div>
                <p
                    className="text-sm text-[#1C1C1A] whitespace-nowrap pt-0.5"
                    data-testid={`product-price-${product.slug}`}
                >
                    ${product.price.toFixed(2)}
                </p>
            </div>
            <button
                type="button"
                onClick={onAdd}
                data-testid={`card-add-to-cart-${product.slug}`}
                className="mt-5 w-full border border-[#1C1C1A] text-[#1C1C1A] py-3 text-[11px] uppercase tracking-[0.22em] font-medium transition-colors duration-200 hover:bg-[#1C1C1A] hover:text-[#FAF9F6]"
            >
                Add to Cart
            </button>
        </Link>
    );
};

export default ProductCard;
